<p-inputNumber
  class="input-term-field"
  [min]="5"
  [max]="maxYears"
  [maxFractionDigits]="0"
  [placeholder]="shortPlaceholder ? 'y' : 'years'"
  [suffix]="shortPlaceholder ? ' y' : ' years'"
  [disabled]="disabled"
  (blur)="onBlur()"
  [(ngModel)]="years" />
<p-inputNumber
  class="input-term-field"
  [min]="0"
  [max]="years === maxYears ? 0 : 11"
  [maxFractionDigits]="0"
  [placeholder]="shortPlaceholder ? 'm' : 'months'"
  [suffix]="shortPlaceholder ? ' m' : ' months'"
  [disabled]="disabled"
  (blur)="onBlur()"
  [(ngModel)]="months" />
@if (disabled) {
  <shared-icon class="disabled-icon" icon="lock" height="1rem" width="1rem" />
}
